import React from 'react';
import './Input.scss';
import Arrow from '../Icons/Arrow';
import { COLORS } from '../../../constants/colors';

/**
 * Renders an input
 * @param {string} type
 * @param {string} placeholder
 * @param {string} id
 * @param {string} color
 * @param {function} fieldRef
 * @param {boolean} isDisabled
 * @param {string} name
 * @returns {JSX.Element}
 * @constructor
 */
const Input = ({ type, placeholder, id, color, fieldRef, isDisabled, name, onBlur }) => {
  const checkType = type === 'text' ? 'c-input__text' : '';

  const DARK_MODES = ['orange', 'gray', 'dark-gray', 'white'];

  return (
    <div className={`c-input ${checkType}`}>
      <label htmlFor={id}>Email address</label>
      <input
        id={id}
        name={name}
        className={`body-2 ${
          DARK_MODES.includes(color) ? 'dark-mode color-black' : 'light-mode color-white'
        }`}
        type={type}
        placeholder={placeholder}
        ref={fieldRef}
        onBlur={onBlur}
      />
      <button name="submit" aria-label="submit" className="c-input__submit" disabled={isDisabled}>
        <Arrow color={DARK_MODES.includes(color) ? COLORS.black : COLORS.white} />
      </button>
    </div>
  );
};

export default Input;
